import { Component, Injector, Optional, Input } from '@angular/core';

import { InstrumentService } from 'src/app/core/service/instrument.service';
import { Instrument } from 'src/app/core/dto/instrument';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { TypeCalculatie } from 'src/app/core/dto/type-calculatie';
import { Groep } from 'src/app/core/enums/groep';
import { Relatie } from 'src/app/core/dto/relatie';
import { startWith, takeUntil } from 'rxjs/operators';
import { ProjectregelService } from 'src/app/core/service/projectregel.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { InstrumentRelatieComponent, InstrumentRelatieDialogData } from '../InstrumentRelatie/instrumentrelatie.component';

@Component({
    selector: 'c-i-j-borculo-instrument-collection',
    templateUrl: './instrument-collection.component.html'/*,
    styleUrls: ['./instrument-collection.component.css'] */
})
export class InstrumentCollectionComponent extends PagedCollectionComponent<Instrument> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Instrument>([
		{ colDef: 'relatie', prop: x => x.relatie.naam1, searchable: SearchableType.String },
		{ colDef: 'groep', prop: x => x.groep, searchable: { type: SearchableType.Enum, enum: Groep } },
		{ colDef: 'soort', prop: x => x.soort, searchable: SearchableType.String },
		{ colDef: 'merk', prop: x => x.merk, searchable: SearchableType.String },
		{ colDef: 'type', prop: x => x.type, searchable: SearchableType.String },
		{ colDef: 'nr_Instrument', prop: x => x.nr_Instrument, searchable: SearchableType.String },
		{ colDef: 'nr_Fabriek', prop: x => x.nr_Fabriek, searchable: SearchableType.String },
		{ colDef: 'nr_Barcode', prop: x => x.nr_Barcode, searchable: SearchableType.String },
		{ colDef: 'nr_Referentie', prop: x => x.nr_Referentie, searchable: SearchableType.String },
		{ colDef: 'lokatie', prop: x => x.lokatie, searchable: SearchableType.String },
		{ colDef: 'centixId', prop: x => x.centixId, searchable: SearchableType.String },
		{ colDef: 'isVervallen', prop: x => x.isVervallen, searchable: SearchableType.Boolean },
		{ colDef: 'isVerlopen', prop: x => x.isVerlopen, searchable: SearchableType.Boolean },
		{ colDef: 'isWerkstandaard', prop: x => x.isWerkstandaard, searchable: SearchableType.Boolean },
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: InstrumentService, @Optional() protected filter: Filter<Instrument>, injector: Injector, private projectregelService: ProjectregelService, private dialog: MatDialog) {
        super('/instrument/instrument', injector, Instrument);

		this.initInput('relatieID', this.filterBuilder.equal(x => x.relatie.id));
    }

	ngOnInit() {
		
		this.buildCustomActions(config => config.add({
			  icon: 'download',
			  name: "",
			  pin: true,
			  show: () => this.authScheme.canDo("CIJBorculo.Logic.InstrumentExportRequest"),
			  fn: () => this.DownloadExcel()
		}));

		this.buildCustomActions(config => {
            this.addSimpleMultiSelectAction({
                config,
                show: this.authScheme.canDo("CIJBorculo.Logic.InstrumentChangeRelatieRequest"),
                fn: (items: Instrument[]) => {
                        this.ChangeRelatie(items);                        
                        return true;
                },
                icon: 'people_alt',
                title: 'Wijzig Relatie',
                isSelectable: item => (true)
            })
        });

		super.ngOnInit();
		
		this.filter.onGetChipLabel(x => x.relatie.naam1, () => 'Relatie');
		this.filter.onGetChipLabel(x => x.groep, () => 'Groep');
		this.filter.onGetChipLabel(x => x.soort, () => 'Soort');
		this.filter.onGetChipLabel(x => x.type, () => 'Type');
		this.filter.onGetChipLabel(x => x.merk, () => 'Merk');
		this.filter.onGetChipLabel(x => x.nr_Instrument, () => 'Nr Instrument');
		this.filter.onGetChipLabel(x => x.nr_Fabriek, () => 'Nr Serie/Fabriek');
		this.filter.onGetChipLabel(x => x.nr_Barcode, () => 'Barcode');
		this.filter.onGetChipLabel(x => x.nr_Referentie, () => 'Nr Referentie');
		this.filter.onGetChipLabel(x => x.lokatie, () => 'Locatie');
		this.filter.onGetChipLabel(x => x.isVervallen, () => 'Vervallen');
		this.filter.onGetChipLabel(x => x.isVerlopen, () => 'Verlopen');
		this.filter.onGetChipLabel(x => x.isWerkstandaard, () => 'Werkstandaard');
	}

	ChangeRelatie(items: Instrument[]){

		const dialogConfig = new MatDialogConfig<InstrumentRelatieDialogData>();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "500px";
        dialogConfig.data = { relatie: null}
        
        this.dialog.open(InstrumentRelatieComponent, dialogConfig).afterClosed()
            .subscribe(response =>  {
                if (response.data != null){                    
                    // Request uitvoeren 
					this.service.changeRelatie(items, response.data.id).toPromise().then(
						(value) => {
							if (value.successful) {
								this.dataSource.update();
								this.dialogs.snackAction("Instrumenten zijn van relatie gewisseld!", ()=>{},"ok", 3000);
							}
						});
                } else {
					this.dialogs.snackAction("U heeft geen relatie geselecteerd", ()=>{},"ok", 3000);
				}
            }
        );
		
	}

	DownloadExcel() {
		this.service.downloadExcelFile(this.filter).toPromise().then(
			(value) => {
				if (value.successful) {
						var blob = this.projectregelService.ConvertResponseToBlob(value);
						var url = window.URL.createObjectURL(blob);
						let anchor = document.createElement('a');
						anchor.href = url;
						
						if (value.fileName) {
							anchor.setAttribute('download', value.fileName);
						}
						anchor.target = '_blank';
						anchor.click();
					}
					else {
						this.dialogs.snackAction("Het document is niet gevonden!", ()=>{},"ok", 3000);
					}
			});
	}

	getGroep(value) {

		switch (Number(value)) {
			case Groep.MeetInstrument:
				return "MI";
			case Groep.Energie:
				return "EN";
			case Groep.Beide:
				return "MI & EN";
			default:
				return value;
		}
	}

	canDelete()	{
		return false;
	}
	
	@Input() set relatieID(val: Relatie) { this.handleInput('relatieID', val.id); }

}